import type { ReactNode } from "react"
import styles from "./PageHeader.module.scss"
import {
  NavigationMenuTrigger,
  UserInitialButton,
  UserName,
} from "src/components"

interface Props {
  children?: ReactNode;
}

export function HomeHeaderWithNoFollows(props: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.spacer}/>
      <div className={styles.centerText}>
        <div
          className={styles.title}
          id={"page-title"}
        >
          {props.children}
        </div>
        <div
          className={styles.userName}
          id="user-name-header"
        >
          <UserName user="account" />
        </div>
      </div>
      <NavigationMenuTrigger asChild>
        <UserInitialButton
          className={styles.menuButton}
          user="account"
        />
      </NavigationMenuTrigger>
    </div>
  )
}
